/**
 * Права ролей на стороне интерфейса — чтобы не показывать кнопку, которая
 * заведомо вернёт 403. Источник правды всё равно бэкенд: здесь только то, что
 * он уже проверяет (app/auth/dependencies.py, ALLOWED_DASHBOARD_ROLES).
 */

import type { Me, Role } from '@/api/types'

/** Вход в интерфейс: только руководитель и администратор (как в старой панели). */
export const DASHBOARD_ROLES: Role[] = ['manager', 'admin']

export function canOpenDashboard(role: Role): boolean {
  return DASHBOARD_ROLES.includes(role)
}

/** Руководитель тоже видит раздел «Пользователи» (своих точек), но не редактирует. */
export function canViewUsers(user: Me | undefined): boolean {
  return user?.role === 'admin' || user?.role === 'manager'
}

export function canManageUsers(user: Me | undefined): boolean {
  return user?.role === 'admin'
}

export function canManageLocations(user: Me | undefined): boolean {
  return user?.role === 'admin'
}

export function canManageScenarios(user: Me | undefined): boolean {
  return user?.role === 'admin' || user?.role === 'manager'
}

export function canDeleteSessions(user: Me | undefined): boolean {
  return user?.role === 'admin'
}

export function canRefreshReview(user: Me | undefined): boolean {
  return user?.role === 'admin' || user?.role === 'manager'
}

export function canSeeDemo(user: Me | undefined): boolean {
  return user?.role === 'admin'
}

/** Фильтр по точке имеет смысл только тем, кто видит больше одной. */
export function canFilterByLocation(user: Me | undefined): boolean {
  return user?.role === 'admin' || user?.role === 'auditor'
}
